const prefixCls = 'web.alibaba.';

export const localesAlibaba = {
  [prefixCls + 'title']: {
    zh_CN: '1688采集列表',
    en_GB: '1688 Collection List',
  },
  [prefixCls + 'search.placeholder']: {
    zh_CN: '输入关键词搜索',
    en_GB: 'Enter keywords to search',
  },
  [prefixCls + 'button.search']: {
    zh_CN: '搜索',
    en_GB: 'Search',
  },
  [prefixCls + 'button.add']: {
    zh_CN: '新增',
    en_GB: 'Add',
  },
  [prefixCls + 'column.id']: {
    zh_CN: '1688ID',
    en_GB: '1688 ID',
  },
  [prefixCls + 'column.product']: {
    zh_CN: '商品名称',
    en_GB: 'Product Name',
  },
  [prefixCls + 'column.sku']: {
    zh_CN: 'sku数量',
    en_GB: 'SKU Count',
  },
  [prefixCls + 'column.time']: {
    zh_CN: '成交时间',
    en_GB: 'Transaction Time',
  },
  [prefixCls + 'column.action']: {
    zh_CN: '操作',
    en_GB: 'Action',
  },
  [prefixCls + 'action.detail']: {
    zh_CN: '上架到noon',
    en_GB: 'Upload to noon',
  },
  [prefixCls + 'detail.title']: {
    zh_CN: '1688上架',
    en_GB: '1688 Upload',
  },
  [prefixCls + 'button.cancel']: {
    zh_CN: '取消',
    en_GB: 'Cancel',
  },
  [prefixCls + 'button.submit']: {
    zh_CN: '提交',
    en_GB: 'Submit',
  },
  [prefixCls + 'detail.notFound']: {
    zh_CN: '未找到相关数据',
    en_GB: 'No data found',
  },
};
